'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_Fetcher$$anon$4() {
}
export { $c_Lpresto_Fetcher$$anon$4 as $c_Lpresto_Fetcher$$anon$4 };
$p = $c_Lpresto_Fetcher$$anon$4.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_sr_AbstractPartialFunction();
$p.constructor = $c_Lpresto_Fetcher$$anon$4;
/** @constructor */
function $h_Lpresto_Fetcher$$anon$4() {
}
export { $h_Lpresto_Fetcher$$anon$4 as $h_Lpresto_Fetcher$$anon$4 };
$h_Lpresto_Fetcher$$anon$4.prototype = $p;
$p.ky = (function(x) {
  return true;
});
$p.ks = (function(x, default$1) {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure(x);
});
$p.ca = (function(x) {
  return this.ky(x);
});
$p.bk = (function(x, default$1) {
  return this.ks(x, default$1);
});
var $d_Lpresto_Fetcher$$anon$4 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_Fetcher$$anon$4, "presto.Fetcher$$anon$4", ({
  Is: 1,
  a4: 1,
  t: 1,
  z: 1,
  a: 1
}));
export { $d_Lpresto_Fetcher$$anon$4 as $d_Lpresto_Fetcher$$anon$4 };
//# sourceMappingURL=presto.-Fetcher$$anon$4.js.map
